import { gql, useQuery } from '@apollo/client';
import React from 'react';
import styles from './ProvisionEntitySearchPostPill.module.scss';
import SVGIcon from '../../components/SVGIcon';
import PostPill from '../../post/PostPill';
import { PostPolicyAction } from '../../post/postPolicyCheck';
import { provisionPostPolicyCheck } from './provisionAccessCheck';
import alertIcon from '../../icons/alert.svg';
import type {
  ProvisionEntitySearchPostPillQuery,
  ProvisionEntitySearchPostPillQueryVariables,
} from '../../graphql/generated/graphqlTypes';

const POST_QUERY = gql`
  query ProvisionEntitySearchPostPill($id: ID!) {
    post(id: $id) {
      ...PostPill_post
      ...provisionPostPolicyCheck_post
      topics {
        id
        name
      }
    }
  }
  ${PostPill.fragments.post}
  ${provisionPostPolicyCheck.fragments.post}
`;

type PostPillProps = React.ComponentProps<typeof PostPill>;
type ProvisionEntitySearchPostPillProps = Omit<
  PostPillProps,
  'tooltip' | 'post'
> & {
  post: PostPillProps['post'] & { id: string };
  provision: Parameters<typeof provisionPostPolicyCheck>[2];
};

const ProvisionEntitySearchPostPill = ({
  provision,
  ...props
}: ProvisionEntitySearchPostPillProps) => {
  const { data } = useQuery<
    ProvisionEntitySearchPostPillQuery,
    ProvisionEntitySearchPostPillQueryVariables
  >(POST_QUERY, {
    variables: { id: props.post.id },
  });
  const fullPost = data?.post;
  let permissionProps = {};

  if (
    fullPost &&
    !provisionPostPolicyCheck(PostPolicyAction.ViewPost, fullPost, provision)
  ) {
    const postTopics = fullPost.topics ?? [];
    const postTopicNames = postTopics.map((t) => t?.name).join('\n');

    permissionProps = {
      icon: <SVGIcon className={styles.icon}>{alertIcon}</SVGIcon>,
      tooltip:
        postTopics.length > 0
          ? `Users will not have access to this post unless they are added as a member of one of its topics:\n${postTopicNames}`
          : 'Users will not have access to this post unless it is added to a topic that they have access to.',
    };
  }
  return <PostPill {...props} {...permissionProps} />;
};

export default ProvisionEntitySearchPostPill;
